import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Link as MuiLink,
} from '@mui/material';

function UAResourcesTab() {
  const leftColumn = [
    { name: 'Contract & Grant Accounting', url: 'https://research.ua.edu/resources/cga/' },
    { name: 'Economic & Business Engagement', url: 'https://research.ua.edu/economic-development/oebe/' },
    { name: 'Innovation & Commercialization', url: 'https://research.ua.edu/economic-development/oic/' },
    { name: 'Research & Technology Agreements', url: 'https://research.ua.edu/resources/orta/' },
    { name: 'Research ASSIST Office', url: 'https://research.ua.edu/resources/assist/' },
  ];

  const rightColumn = [
    { name: 'Research Communications', url: 'https://research.ua.edu/communications/' },
    { name: 'Research Ethics & Compliance', url: 'https://research.ua.edu/compliance/' },
    { name: 'Research Security & Export Control', url: 'https://research.ua.edu/resources/export-controls/' },
    { name: 'Sponsored Programs', url: 'https://research.ua.edu/osp/' },
    { name: 'Undergraduate Research', url: 'https://undergraduateresearch.ua.edu/' },
  ];

  return (
    <Box sx={{ p: 2 }}>
      {/* Title Section */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          marginBottom: 1,
          color: 'text.primary',
        }}
      >
        UA Resources
      </Typography>

      <Typography
        variant="body1"
        sx={{
          mb: 3,
          fontSize: '1.1rem', // Adjust font size to make it larger
          lineHeight: 1.6,    // Increase line height for better readability
          color: 'text.secondary',
        }}
      >
        The University of Alabama provides a variety of research resources
        through its{' '}
        <MuiLink
          href="https://research.ua.edu/resources/"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          Research Resources site
        </MuiLink>
        . Below are direct links to several useful offices and programs:
      </Typography>

      <Grid container spacing={4}>
        {/* LEFT COLUMN */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              border: '1px solid #ccc',
              borderRadius: 1,
              overflow: 'hidden',
            }}
          >
            {leftColumn.map((item, index) => (
              <Box
                key={item.name}
                sx={{
                  borderBottom:
                    index === leftColumn.length - 1 ? 'none' : '1px solid #ddd',
                  p: 2,
                }}
              >
                <MuiLink
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="hover"
                  sx={{
                    color: 'secondary.main',
                    fontWeight: 500,
                  }}
                >
                  {item.name}
                </MuiLink>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* RIGHT COLUMN */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              border: '1px solid #ccc',
              borderRadius: 1,
              overflow: 'hidden',
            }}
          >
            {rightColumn.map((item, index) => (
              <Box
                key={item.name}
                sx={{
                  borderBottom:
                    index === rightColumn.length - 1 ? 'none' : '1px solid #ddd',
                  p: 2,
                }}
              >
                <MuiLink
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="hover"
                  sx={{
                    color: 'secondary.main',
                    fontWeight: 500,
                  }}
                >
                  {item.name}
                </MuiLink>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default UAResourcesTab;
